






import Typography from '@/components/atoms/Typography/Typography.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: { Typography }
})
export default class Subtitle extends Vue {}
